import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { EvaluatorLoginComponent } from "./components/evaluator-login/evaluator-login.component";
import { EvaluatorHomeComponent } from "./components/evaluator-home/evaluator-home.component";
import { EvaluatorApplicantsComponent } from "./components/evaluator-applicants/evaluator-applicants.component";
import { EvaluatorPortalComponent } from "./components/evaluator-application-list/evaluator-application-list.component";
import { EvaluatorViewOutletComponent } from "./components/evaluator-view-outlet/evaluator-view-outlet.component";
import { EvaluatorViewApplicationComponent } from "./components/evaluator-view-application/evaluator-view-application.component";
import { EvaluatorRegisterComponent } from "./components/evaluator-register/evaluator-register.component";
import { EvaluatorSchedulingComponent } from "./components/evaluator-scheduling/evaluator-scheduling.component";
import { EvaluatorScanQrComponent } from "./components/evaluator-scan-qr/evaluator-scan-qr.component";
import { EvaluatorSchedulingViewComponent } from "./components/evaluator-scheduling-view/evaluator-scheduling-view.component";
import { EvaluatorScanResultComponent } from "./components/evaluator-scan-result/evaluator-scan-result.component";
import { EvaluatorScannerComponent } from "./components/evaluator-scanner/evaluator-scanner.component";
import { EvaluatorScannerOutletComponent } from "./components/evaluator-scanner-outlet/evaluator-scanner-outlet.component";
import { EvaluatorEsigResultComponent } from "./components/evaluator-esig-result/evaluator-esig-result.component";
import { WorkpermitQrResultComponent } from "./components/workpermit-qr-result/workpermit-qr-result.component";
import { EvaluatorVerifyEmailComponent } from "./components/evaluator-verify-email/evaluator-verify-email.component";
import { EvaluatorSuccessComponent } from "./components/evaluator-success/evaluator-success.component";

export const EvaluatorDashboardRoutes: Routes = [
  {
    path: "sign-in",
    component: EvaluatorLoginComponent,
  },
  {
    path: "sign-up",
    component: EvaluatorRegisterComponent,
  },
  {
    path: 'verify',
    component: EvaluatorVerifyEmailComponent,
  },
  {
    path: 'success',
    component: EvaluatorSuccessComponent,
  },

  {
    path: "dashboard",
    component: EvaluatorHomeComponent,
    children: [
      {
        path: "home",
        component: EvaluatorPortalComponent,
      },
      {
        path: "application",
        component: EvaluatorViewOutletComponent,
        children: [
          {
            path: ":id",
            component: EvaluatorViewApplicationComponent,
          },
        ],
      },
      {
        path: "applicants",
        component: EvaluatorApplicantsComponent,
      },
      {
        path: "scanner",
        component: EvaluatorScannerOutletComponent,
        children: [
          {
            path: '',
            component: EvaluatorScannerComponent
          },
          {
            path: 'esig/:id',
            component: EvaluatorEsigResultComponent
          },
          {
            path: 'permit/:id',
            component: WorkpermitQrResultComponent
          }
        ]
      },
      {
        path: "scheduling",
        component: EvaluatorSchedulingComponent,
        children: [
          {
            path: "",
            component: EvaluatorSchedulingViewComponent
          },
          {
            path: "scan",
            component: EvaluatorScanQrComponent
          },
          {
            path: "result/:id",
            component: EvaluatorScanResultComponent
          }
        ]
      },
    ],
  },
];
